import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAdminAddBusinessData } from "../../apis/IApisInterface";
import { addAdminBusinessApi, getAdminMangerDataApi } from "../../apis";
import { showSnackbar } from "../../slices/SnackbarSlice";

export const getAdminMangerDataAction = createAsyncThunk("get/admin-manager/data", async (_, { rejectWithValue }) => {
    try {
        const response = await getAdminMangerDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin manager data" })
    }
})

export const addAdminBusinessAction = createAsyncThunk("admin/add/business", async (placeId: IAdminAddBusinessData, { rejectWithValue, dispatch }) => {
    try {
        const response = await addAdminBusinessApi(placeId)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add business" });
    }
})
